const notification = {
  namespaced: true,
  state: {
    type: '', // type options = success, info, warning, error
    message: '',
    description: '',
    timestamp: Date.now()
  },
  mutations: {
    show(state, { type, message, description }) {
      state.type = type
      state.message = message
      state.description = description
      state.timestamp = Date.now()
    }
  }
}

export default notification